
/* data or computed will need the following properties for this to work: productLine, allSteps, currentStepNumber */
/* also method stepSuccess: function (page, fromstep, tostep) => void has to be implemented */
import twowayBindingMixin from "@/store/twowayBindingMixin";
export default {
  mixins: [ twowayBindingMixin ],
  data() {
    return {
      angebotDialog: {
        show: false,
        title: '',
        width: 500,
        isError: false,
        isSuccess: false,
        pdfUrl: ''
      },
      errorSnackbar: {
        displayerrors: false,
        errormessages: [],
      },
      producterror: false
    };
  },
  computed: {
    showSummaryBox() {
      return this.$vuetify.breakpoint.width > 1200;
    },
  },
  mounted() {
    window.addEventListener('resize', this.setStepperHeaderWidth);
    this.setStepperHeaderWidth();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.setStepperHeaderWidth);
  },
  methods: {
    setStepperHeaderWidth() {
      let payload = { s: { breakpointwidth: this.$vuetify.breakpoint.width, windowinnerwidth: window.innerWidth }};
      this.$store.commit("setObject", payload);

      //position changes to relative for smaller screens
      if(this.$vuetify.breakpoint.width > 1100 && this.$vuetify.breakpoint.height > 800) {
        setTimeout(() => {
          let parent = document.getElementById("stepperpageContent");
          let child = document.getElementById("custom-header-stepper");
          if (parent && child ) child.style.width = `${parent.clientWidth}px`;
        }, 500);
      } else {
        let stepper = document.getElementById("custom-header-stepper");
        if (stepper) stepper.style.width = '100%';
      }
    },
    doStep(page, fromstep, tostep) {
      //enable backwards navigation for initial steps
      if (fromstep > tostep && !this.allSteps[fromstep - 1].complete) {
        this.$store.commit("doStepTo", {
          page: page,
          stepNumber: tostep
        });
        window.scrollTo(0, 0);
        return;
      }
      let fnError = (function () {
        console.log("fnerror DoStep");
        this.openInvalidAccordions(fromstep);
        this.errorSnackbar.errormessages = ["Bitte überprüfen Sie Ihre Eingaben."];
        this.errorSnackbar.displayerrors = true;
      }).bind(this);
      let fnSuccess = (function () {
        if (fromstep === 2 && !this.productLine) {
          this.producterror = true;
          fnError();
          return;
        }
        this.closeAccordions(fromstep);
        this.stepSuccess(page, fromstep, tostep);
      }).bind(this);
      const validations = this.getStepValidators(fromstep).map(v => v.validateAll());
      return Promise.all(validations)
        .then(res => {
          res.includes(false) ? fnError() : fnSuccess();
        })
        .catch(err => {
          console.log(`VALIDATION ERROR: ${err.message}`);
          fnError();
        });
    },
    getStepValidators (step) {
      let validators = [];
      function collectValidators (component) {
        if (component.$validator){
          validators.push(component.$validator);
        }
        if (component.$children){
          component.$children.forEach(collectValidators);
        }
      }
      collectValidators(this.$refs[`compStep${step}`]);
      return validators;
    },
    clearValidation(comp){
      function clearValidators (component) {
        if (component.$validator){
          component.$validator.reset();
        }
        if (component.$children){
          component.$children.forEach(clearValidators);
        }
      }
      clearValidators(comp);
    },
    openInvalidAccordions(step) {
      /* Returns all _uids of the given component and its children.
         Is needed to compare the vmId of the error item and the _uid-s of the current accordion item to check if the error belongs to the
         current item.*/
      function getUids(_uids, comp) {
        if (!_uids) _uids = [];
        _uids.push(comp._uid);
        if (comp.$children && comp.$children.length > 0) {
          comp.$children.forEach(child => _uids = getUids(_uids, child));
        }
        return _uids;
      }
      let accordions = this.collectAccordions(step);
      accordions.forEach(a => {
        let keys = Object.keys(a.$refs || {}).filter(k => /^accordionitem.+$/.test(k));
        let values = [];
        keys.forEach((key) => {
          let index = +key.substr(13);
          if (a.$refs[key].length && a.$refs[key][0].$validator) {
            let errorbag = a.$refs[key][0].$validator.errors;
            const uids = getUids(uids, a.$refs[key][0]);
            if (errorbag.items.filter(e => uids.includes(e.vmId)).length > 0) values.push(+index);
          }
        });
        a.showMultiple = true;
        this.updateState("uiOpenPanel", values, a.statePath); //calls mutation like this: this.$store.commit("setObject", {"gewerbe":{"ui":{"accordions":{"step1Mvu":{"uiOpenPanel":[0]}}}}});
      });
    },
    closeAccordions(step) {
      let accordions = this.collectAccordions(step);
      accordions.forEach(a => {
        a.showMultiple = false;
        // lets close all accordion panels for users coming back
        this.updateState("uiOpenPanel", [], a.statePath);
      });
    },
    collectAccordions(step) {
      let accordions = [];
      function _collectAccordions (component) {
        if (component.$refs){
          let keys = Object.keys(component.$refs).filter(k => /^accordionStep.+$/.test(k));
          keys.forEach(k => {
            // $refs[k] returns an Array ref is set in a v-for loop
            const ref = component.$refs[k];
            if (Array.isArray(ref)) {
              ref.forEach(r => accordions.push(r));
            } else {
              accordions.push(ref);
            }
          });
        }
        if (component.$children){
          component.$children.forEach(_collectAccordions);
        }
      }
      _collectAccordions(this.$refs[`compStep${step}`]);
      return accordions.filter(a => !!a);
    },
    showDialog () {
      this.angebotDialog.isSuccess = false;
      this.angebotDialog.pdfUrl = '';
      this.angebotDialog.isError = false;
      this.angebotDialog.width = 500;
      this.angebotDialog.show = true;
    },
    openAngebot () {
      window.open(this.angebotDialog.pdfUrl, '_blank');
    }
  }
};
